import React from 'react';
import { useSingleSaleTableItemQuantityStyles } from 'components/Payments/SingleSale/Table/Item/Quantity/SingleSaleTableItemQuantity.styles';
import { useCommonStyles } from 'components/UI/CommonStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { faMinusCircle, faPlusCircle } from '@fortawesome/pro-light-svg-icons';
import { Box, Typography } from '@material-ui/core';
import clsx from 'clsx';

interface QuantityProps {
    value: number;
    className?: string;
    onChange: (value: number) => void;
}

export const SingleSaleTableItemQuantity: React.FC<QuantityProps> = props => {
    const commonClasses = useCommonStyles();
    const classes = useSingleSaleTableItemQuantityStyles();

    const iconSVG = (icon: IconDefinition, styles: string) => {
        return (
            <FontAwesomeIcon
                icon={icon}
                className={styles}
            />
        );
    };

    const reduceQtyHandler = (value: number) => {
        props.onChange(value === 0 ? 0 : value - 1);
    };

    const addQtyHandler = (value: number) => {
        props.onChange(value + 1);
    };

    return (
        <Box className={clsx(classes.container, props.className)}>
            <Box className={clsx(commonClasses.flexRowCenter, classes.boxQty)}>
                <Box onClick={() => reduceQtyHandler(props.value)}>
                    {iconSVG(faMinusCircle, `${classes.sectionIconQty}`)}
                </Box>
                <Typography className={clsx(classes.typoAmount)}>{props.value}</Typography>
                <Box onClick={() => addQtyHandler(props.value)}>
                    {iconSVG(faPlusCircle, `${classes.sectionIconQty}`)}
                </Box>
            </Box>
        </Box>
    );
};
